"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function onSuccess(actionContext, _ref) {
  var response = _ref.response,
    onSuccessCallback = _ref.options.onSuccessCallback;
  actionContext.dispatch('RETRIEVE_NOTIFICATION_COUNT_SUCCESS', {
    pendingTotal: response.data.total
  });
  onSuccessCallback();
}
var _default = function _default(config) {
  return {
    serviceName: 'retrieveNotificationCount',
    authenticate: true,
    config: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      url: (0, _get.default)(config, 'endpoints.prompt.notifications.count')
    },
    onSuccess: onSuccess
  };
};
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(onSuccess, "onSuccess", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/retrieve-notification-count.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/services/service-configs/notifications/retrieve-notification-count.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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